import { CloseButton, Drawer, Portal, Text, VStack } from '@chakra-ui/react'

/** [Canvasser redesign Phase 8 / P8-11] Plain-language "how we figure this". Names no study (Jason). Makes no
 * persuasion claim (spec D11). Votes off hides only the votes paragraphs; the race paragraph follows the context. */
export function ImpactExplainerSheet({ open, onClose, perVote, hasContext }: {
  open: boolean; onClose: () => void; perVote: number | null; hasContext: boolean
}) {
  return (
    <Drawer.Root open={open} placement="bottom" onOpenChange={(e) => { if (!e.open) onClose() }}>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content borderTopRadius="xl" pb="env(safe-area-inset-bottom, 0px)" shadow="popover">
            <Drawer.CloseTrigger asChild><CloseButton size="sm" minW="48px" minH="48px" /></Drawer.CloseTrigger>
            <Drawer.Header><Drawer.Title>How we figure this</Drawer.Title></Drawer.Header>
            <Drawer.Body>
              <VStack align="stretch" gap={3} pb={4}>
                {perVote != null && (
                  <>
                    <Text>
                      {`Studies of door-to-door canvassing find that about one extra person votes for every ${perVote} real conversations. We use that rate to estimate the votes you and your team add.`}
                    </Text>
                    <Text>It's an estimate, not a count. Nobody can know exactly which people voted because you knocked.</Text>
                    <Text>It's about turnout, helping people get out and vote, not about changing anyone's mind.</Text>
                  </>
                )}
                <Text>Conversations are doors where you talked with someone. Not home, refused and other outcomes don't count.</Text>
                <Text>People talked to counts each person once, out of everyone on your campaign's current turf.</Text>
                {hasContext && (
                  <Text>The race result comes from past official results in the precincts your campaign is walking.</Text>
                )}
              </VStack>
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  )
}
